import { useCallback } from 'react';
import { useStartFinishErrors } from '@backpackjs/storefront';

export const useBackInStock = () => {
  const { setStarted, setFinished, setErrors, reset, ...status } =
    useStartFinishErrors();

  const subscribeToBackInStock = useCallback(async ({ email, variantId }) => {
    try {
      if (!email) {
        return console.error('Missing required parameter: email');
      }
      if (!variantId) {
        return console.error('Missing required parameter: variant');
      }

      reset();
      setStarted(true);
      const url = `/api/klaviyo`;
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'postBackInStock',
          email,
          variant: variantId,
        }),
      };
      const response = await fetch(url, options);
      const data = await response.json();
      if (data?.success) {
        setFinished(true);
        return data;
      }
      setErrors(['Error with subscribing to back in stock.']);
      console.error(`Response back from API not successful: ${data}`);
      return null;
    } catch (error) {
      setErrors(['Error with subscribing to back in stock.']);
      console.error(`Error with subscribeToBackInStock: ${error}`);
    }
  }, []);

  return {
    subscribeToBackInStock,
    setErrors,
    reset,
    ...status,
  };
};
